module.exports = __webpack_public_path__ + "img/check_await.f318ee06.svg";